import { combineReducers, configureStore } from "@reduxjs/toolkit";
import apiReportReducer from "./slices/apiReportSlice.ts";
import { chartFieldsReducer } from "./slices/chartStateSlice.ts";
import clientSettingsReducer from "./slices/clientSettingsSlice.ts";
import currentReportReducer from "./slices/currentReportSlice";
import devPanelConfigurationReducer from "./slices/devToolsSlice.ts";
import drillDownConfigurationReducer from "./slices/drillDownConfigurationSlice.ts";
import drillDownPageReducer from "./slices/drillDownPageSlice.ts";
import fieldsStateReducer from "./slices/fieldsStateSlice.ts";
import measureDatasetsReducer from "./slices/measureDataSetsSlice.ts";
import metaDataReducer from "./slices/metaDataSlice.ts";
import { pivotFieldsReducer } from "./slices/pivotFieldsSlice.ts";
import reportsReducer from "./slices/reportsSlice.ts";
import reportTemplatesReducer from "./slices/reportTemplatesSlice.ts";
import { tabularFieldsReducer } from "./slices/tabularFieldsSlice.ts";
import { tileFieldsReducer } from "./slices/tileFieldsSlice.ts";
import uiSettingsREducer from "./slices/uiSettingsSlice.ts";

const combinedReducer = combineReducers({
  fieldsStateReducer,
  tabularFieldsReducer,
  pivotFieldsReducer,
  chartFieldsReducer,
  tileFieldsReducer,
});

export const store = configureStore({
  reducer: {
    fieldsState: combinedReducer,
    currentReport: currentReportReducer,
    metaData: metaDataReducer,
    measureDatasets: measureDatasetsReducer,
    drillDownPage: drillDownPageReducer,
    drillDownConfiguration: drillDownConfigurationReducer,
    devTools: devPanelConfigurationReducer,
    reportTemplates: reportTemplatesReducer,
    reports: reportsReducer,
    apiReport: apiReportReducer,
    clientSettings: clientSettingsReducer,
    uiSettings: uiSettingsREducer,
  },
});

export type AppDispatch = typeof store.dispatch;
